import { ButtonProps } from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useMemo } from "react";
import { Dialog } from "../../../components/Dialog";
import { Autocomplete } from "../../../components/Autocomplete";
import { DatePicker } from "../../../components/DatePicker";

type DialogEditArtProps = {
  open: boolean;
  onClose: () => void;
};

export function DialogEditArt({ onClose, open }: DialogEditArtProps) {
  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Cancelar",
        onClick: onClose,
      },
      {
        children: "Editar",
        variant: "contained",
      },
    ];
  }, [onClose]);

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={open}
      actions={actions}
      title="Informações da propaganda"
    >
      <Stack spacing={2}>
        <TextField size="small" label="Nome" />
        <Autocomplete
          size="small"
          fullWidth
          label="Lojas"
          options={[]}
          placeholder="Selecionar loja"
          getOptionLabel={(option) => option.name}
        />
        <Stack spacing={4} direction="row">
          <DatePicker
            label="De"
            fullWidth
            size="small"
            onChange={console.log}
          />
          <DatePicker
            label="Até"
            fullWidth
            size="small"
            onChange={console.log}
          />
        </Stack>
      </Stack>
    </Dialog>
  );
}
